import React from 'react';
import '../CSS/Attendance.css';
import LeftArrow from '../Images/leftArrow.png';
import Refresh from '../Images/refresh.png';
import {useHistory} from 'react-router-dom';
import Loading from '../Components/Loading';
import Model from '../Components/Attendance/Model'
import Flatlist from 'flatlist-react';
import {Doughnut} from 'react-chartjs-2';
import {Card} from '@material-ui/core';
import { motion} from 'framer-motion';
import { pageTransition, pageStyle, pageVariants } from '../Components/Animations/Transition';
import {getUrl} from '../Functions.js';

function Attendance(props) {
  const history  = useHistory();
  if(localStorage.getItem("loggedIn")!=="true"){
    history.push("/opening");
  }
  const cookie = localStorage.getItem("cookie");
  const [loading, setLoading] = React.useState(true);
  const [attendance, setAttendance] = React.useState([]);
  const [status, setStatus] = React.useState([]);
  const [green, setGreen] = React.useState("");
  const [yellow, setYellow] = React.useState("");
  const [red, setRed] = React.useState("");
  const [grey, setGrey] = React.useState("");
  const [overall, setOverall] = React.useState("");
  var update = false;
  const loadingHeight = "78vh";
  const chartData = {
    labels : ['yet to start','0-74','75-84','85-100'],
    datasets : [{
    backgroundColor : [
      '#4B515D',
      '#ff4444',
      '#ffbb33',
      '#00C851'
    ],
    hoverBackgroundColor: [
    '#3E4551',
    '#CC0000',
    '#FF8800',
    '#007E33',
    ],
    data : status
   }]};

  const options = {
    method : 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ 
      cookies:cookie
    })

    
  }
  function back(){
    history.push("/home");
  }

  function fetchData(){
    if(localStorage.getItem("loggedIn")!=="true"){
      history.push("/opening");
    }
    setLoading(true);
    setStatus([]);
    setGreen("")
    setGrey("");
    setOverall("");
    setRed("");
    setYellow("");
    setAttendance([]);
    fetch(getUrl() + 'attendance', options)
      .then(response => response.json()).then(
        data =>{
          if(data.retry===true){
            console.log("retrying...");
            fetchData();
          }else{
            setAttendance(data.attendance);
            setStatus(data.status.reverse());
            setLoading(false);
            if(status[3]!==0&&status[3]!==undefined){
              setGreen("85-100 : " + status[3]);
            }
            if(status[2]!==0&&status[2]!==undefined){
              setYellow("75-84 : " + status[2]);
            }
            if(status[1]!==0&&status[1]!==undefined){
              setRed("0-74 : " + status[1]);
            }
            if(status[0]!==0&&status[0]!==undefined){
              setGrey("yet to start : " + status[0]);
            }
            setOverall("Overall")
            update = false;
          }
        }
      );
  }
  
  React.useEffect(() => {
    fetchData();
  },[]);

  return (
    <motion.div className="Attendance"
    initial="initial"
    animate="in"
    exit="out"
    style={pageStyle}
    variants={pageVariants}
    transition={pageTransition}>
      <div className="TopMainAttendance">
        <div className="TopAndChartAttendance">
          <div className="TopAttendance">
            <img src={LeftArrow} alt="back" className="BackAttendance" onClick={()=>{
              back();
            }} color="#000000" />
            <div ></div>
            <img src={Refresh} alt="refresh" className="RefreshAttendance" onClick={()=>{
              if(update!==true){
                update = true;
                fetchData();
              }}} color="#000000"/>
          </div>    
          <div className="ChartDivAttendance">
            <div className="ChartAttendance">
              <Doughnut
                height={60}
                width={60}
                data={chartData}
                
                options={{
                  cutoutPercentage:75,
                  maintainAspectRatio: false ,
                  title:{
                    display:false
                  },
                  legend:{
                    display:false
                  },
                }}
                />
              </div>
              <div className="AttendanceNumbersAttendance">
                <div className="ChartAttendanceOverallAttendance">
                  {overall}
                </div>
                <div className="ChartAttendanceNumbersAttendance">
                  {green}
                </div>
                <div className="ChartAttendanceNumbersAttendance">
                  {yellow}
                </div>
                <div className="ChartAttendanceNumbersAttendance">
                  {red}
                </div>
                <div className="ChartAttendanceNumbersAttendance">
                  {grey}
                </div>
                </div>  
          </div>
          
        
        </div>
        <div className="BottomAttendance">
          <Card
              raised
              className="AttendanceTextAttendance"
              style={{
                  backgroundColor:"#ffffff",
                  borderRadius:"20px",
                  borderTopLeftRadius:"0px",
                  borderTopRightRadius:"0px",
                  zIndex:"12",
                  marginTop:"2px"
              }}>
                  Attendance
              </Card>
          </div>
      </div>
      <div >
        {loading===true?<Loading height={loadingHeight} color="#ff6247"/>:""}
        
        <div className="FlatListAttendance">
          <Flatlist
            list={attendance}
            renderItem={(item,index)=><Model item={item} index={index}/>}
            renderWhenEmpty={() => <div></div>}
            renderOnScroll
            />
            
        </div>
      </div>
    </motion.div>
  );

}



export default Attendance;